import { render, staticRenderFns } from "./InviteesListItem.vue?vue&type=template&id=ddd1a3cc&scoped=true&"
import script from "./InviteesListItem.vue?vue&type=script&lang=js&"
export * from "./InviteesListItem.vue?vue&type=script&lang=js&"
import style0 from "./InviteesListItem.vue?vue&type=style&index=0&id=ddd1a3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd1a3cc",
  null
  
)

export default component.exports